/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/jsx-curly-newline */
import React, { useState } from 'react';
import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import { SettingsButton } from 'src/components';
import { RegularButton } from 'pg-ui-library';
import { IDependent } from 'src/interfaces';
import { maskLastFourCharacters } from 'src/utils/formatDateConvert';
import { ItemContainer, Container, HeaderLine, HeaderRightItems, TitleWrapper, TitleWrapperText } from './styles';
import { EmployeeDependentsTable } from './components/employee-dependents-table';
import { PersonalDependentsModal } from './components/personal-dependents-modal';

const initialColumns: TableColumn<IDependent>[] = [
  {
    name: 'First Name',
    selector: (row: IDependent) => row.firstName,
  },
  {
    name: 'Last Name',
    selector: (row: IDependent) => row.lastName,
  },
  {
    name: 'Relationship Type',
    selector: (row: IDependent) => row.relationship ?? '',
  },
  {
    name: 'Birth Date',
    selector: (row: IDependent) => maskLastFourCharacters(row.birthDate as string) ?? '',
  },
  {
    name: 'Gender',
    selector: (row: IDependent) => row.gender ?? '',
  },
];

const PersonalDependentsTab: React.FC = () => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<TableColumn<IDependent>[]>(initialColumns);
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Container>
      <ItemContainer>
        <TitleWrapper>
          <TitleWrapperText>{t('employeePage.personalTab.dependents.title')}</TitleWrapperText>
          <HeaderLine />
          <HeaderRightItems>
            <RegularButton onClick={() => setIsOpen(!modalIsOpen)}>
              {t('employeePage.personalTab.dependents.addButton')}
            </RegularButton>
            <SettingsButton columns={columns} setColumns={setColumns} />
          </HeaderRightItems>
        </TitleWrapper>
        <EmployeeDependentsTable columns={columns} />
        <PersonalDependentsModal isOpen={modalIsOpen} setIsOpen={setIsOpen} />
      </ItemContainer>
    </Container>
  );
};

export default PersonalDependentsTab;
